export default {
    age: 'العمر',
    '18-22': '18-22',
    '23-27': '23-27',
    '28-32': '28-32',
    '33-37': '33-37',
    '38-42': '38-42',
    '43-47': '43-47',
    '48-52': '48-52',
    '53+': '53+',
    gender: 'النوع',
    male: 'رجل',
    female: 'انثى',
    contactWays: 'طريقة التواصل',
    whatsapp: 'واتساب',
    email: 'الايميل',
    facebook: 'فايسبوك',
    website: 'الموقع',
    country: 'بلد الاقامة',
    lebanon: 'لبنان',
    egypt: 'مصر',
    iraq: 'العراق',
    syria: 'سوريا',
    'saudi arabia': 'السعودية',
    uae: 'الامارات',
    qatar: 'قطر',
    bahrain: 'البحرين',
    kuwait: 'الكويت',
    yemen: 'اليمن',
    oman: 'سلطنة عمان',
    jordan: 'الاردن',
    palestine: 'قلسطين',
    morocco: 'المغرب',
    tunisia: 'تونس',
    algeria: 'الجزائر',
    libya: 'ليبيا',
    sudan: 'السودان',
    mauritania: 'موريتانيا',
    usa: 'امريكا',
    canada: 'كندا',
    australia: 'اوستراليا',
    russia: 'روسيا',
    'european country': 'دولة اوروبية',
    'asian country': 'دولة اسيوية',
    'south america': 'امريكا الجنوبية',
    'other country': 'دولة اخرى',
    educationalLevel: 'المؤهل العلمي',
    none: 'غير متعلم',
    school: 'مدرسي',
    university: 'دراسة جامعية',
    postgraduate: 'دراسات عليا',
    other: 'غير ذلك',
    height: 'طويل',
    short: 'قصير',
    average: 'متوسط',
    tall: 'الطويل',
    undefined: 'غير ذلك',
    job: 'العمل',
    student: 'طالب',
    'private employee': 'قطاع خاص',
    'public sector': 'قطاع عام',
    finance: 'بنوك',
    teaching: 'تدريس',
    medicine: 'قطاع الطب',
    jounalist: 'صحافة',
    business: 'اعمال',
    commerce: 'تجارة',
    unemployed: 'لا شيئ',
    pension: 'متقاعد',
    military: 'عسكري',
    kids: 'هل لديك أطفال؟',
    yes: 'نعم',
    no: 'لا',
    maritalStatus: 'الحالة الاجتماعية',
    married: 'متزوج',
    single: 'اعزب',
    divorced: 'مطلق',
    widowed: 'ارمل',
    originCountry: 'بلد الاصل',
    purpose: 'الهدف من الموقع',
    'normal marriage': 'زواج عادي',
    'mesyar marriage': 'زواج مسيار',
    polygamy: 'تعدد',
    'new contacts': 'علاقة جديدة',
    'internet friends': 'صداقة عبر النت',
    'share stories': 'تبادل افكار',
    'meet new people': 'تعرف على اناس جدد',
    'meet new culture': 'تعرف على ثقافة جديدة',
    eyeColor: 'لون العيون',
    skinColor: 'لون البشرة',
    hairColor: 'لون الشعر',
    black: 'اسود',
    blue: 'ازرق',
    green: 'اخضر',
    white: 'ابيض',
    brown: 'بني',
    'dark brown': 'بني غامق',
    'light brown': 'بني فاتح',
    blonde: 'أشقر',
    olive: 'زيتي',
    yellow: 'اصفر',
    hazel: 'بندقي',
    red: 'احمر',
    gray: 'رمادي',
    ginger: 'زنجبيل',
    weight: 'الوزن',
    light: 'رفيع',
    medium: 'عادي',
    chubby: 'بدين',
    clear: 'مسح الخيارات'
}
